// extracted by mini-css-extract-plugin
module.exports = {"article":"news-post-module--article--3xAya","poster":"news-post-module--poster--3yTZV","landscape":"news-post-module--landscape--1ne5g"};